import React from 'react';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import AccountingExpensesCard from './AccountingExpensesCard';
import { trMoney } from '../../utils/accountingFormat';

function SummaryCard({ title, value, surface, border }) {
  return (
    <Card
      sx={{
        borderRadius: '16px',
        border: `1px solid ${border}`,
        background: surface,
        boxShadow: 'none',
      }}
    >
      <MDBox sx={{ p: 1.2 }}>
        <MDTypography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800 }}>
          {title}
        </MDTypography>
        <MDTypography variant="h6" fontWeight="bold">
          {value}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default function AccountingExpenseTab({ surface, surface2, border, q, setQ, data }) {
  return (
    <MDBox sx={{ display: 'grid', gap: 1.5 }}>
      <Grid container spacing={1.5}>
        <Grid item xs={12} md={4}>
          <SummaryCard
            title="Toplam Gider"
            value={trMoney(data.totalExpensePaid + data.totalExpensePending)}
            surface={surface}
            border={border}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            title="Odenen Gider"
            value={trMoney(data.totalExpensePaid)}
            surface={surface}
            border={border}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard
            title="Bekleyen Gider"
            value={trMoney(data.totalExpensePending)}
            surface={surface}
            border={border}
          />
        </Grid>
      </Grid>

      <Alert severity="info" sx={{ borderRadius: '16px' }}>
        Bekleyen giderleri ve yapilan gider odemelerini ayni ekranda ayri tutuyoruz. Bir kaydin
        durumunu satir aksiyonlariyla ya da surukle birak ile degistirebilirsin.
      </Alert>

      <TextField
        size="small"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Ara: gider / kategori / aciklama"
        sx={{
          width: { xs: '100%', md: 420 },
          '& .MuiOutlinedInput-root': {
            borderRadius: '14px',
            background: surface2,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon fontSize="small">search</Icon>
            </InputAdornment>
          ),
        }}
      />

      <AccountingExpensesCard
        rows={data.rows}
        onCreateExpense={data.createExpense}
        onMarkExpensePaid={data.markExpensePaid}
        onMarkExpensePending={data.markExpensePending}
        onDeleteExpense={data.deleteExpense}
      />
    </MDBox>
  );
}
